import ApiService from '@/common/api.service'
import * as utils from '@/common/utils'

export const state = {
  /*
   * statusSelectionSets is a "grouping" of multiple status types that are
   * selected. For example, one might wish to have a "global" set of
   * selected statuses that is persistent across all screens or one
   * might want to create a set of selected report type for a particular
   * individual/group of widgets.
   */
  statusSelectionSets: {},
  queryByScheduleId: null
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected vehicles.
   *
   * @param state Object
   *
   * @return Object
   */
  statusSelectionSets (state) {
    return state.statusSelectionSets
  },

  /**
   * Returns the report_schedule_id of which the schedule
   * statuses must be queried.
   *
   * @param state
   *
   * @return {Object|null}
   */
  getScheduleId (state) {
    return state.queryByScheduleId
  }
}

export const actions = {
  /**
   * Query/find one or more schedule statuses for the current
   * report schedule.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    const reportType = utils.storeGetProp('reports/reportsModule', 'report_type')

    const queryByScheduleId = context.getters['getScheduleId']
    return ApiService
      .get(`reports/schedule/${reportType}/${queryByScheduleId}/status`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Purge the module's state.
   *
   * @param state Object
   */
  purge (state) {
    state.statusSelectionSets = {}
    state.queryByScheduleId = null
  },

  /**
   * Sets the schedule id for which the schedule statuses should be queried.
   *
   * @param state
   * @param id int|null
   */
  setScheduleId (state, id) {
    state.queryByScheduleId = id
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/reports/findReportScheduleStatusModule.js